import React, { useEffect, useState } from 'react';
import { message, DatePicker, Form, Input, Select, Skeleton } from "antd";
import { Button, Text } from "evergreen-ui";
import FireFetch from "../../Firebase/FireFetch";
import Firebase from "../../Firebase/Firebase";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref, update } from "firebase/database";
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


const { TextArea } = Input;
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");
const EditInteraction = (props) => {
	const { canAccessModule } = useAuth();
	const canUpdateInteraction = canAccessModule("INTERACTIONS", "update");

	const [filesList, setFilesList] = useState([]);
	const [folderID, setFolderID] = useState(null);
	const [showLoading, setShowLoading] = useState(false);
	const [organizationArray, organizationsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [userArray, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
	const [lessonArray, lessonsLoading] = useListVals(ref(db, "talmidsdb/lessons"));
	const [date, setDate] = useState(null);
	const [interaction, setInteraction] = useState(props.interaction);
	const [commArray, setCommArray] = useState([]);
	const [specify, setSpecify] = useState(false);
	const isLookupLoading =
		organizationsLoading ||
		communitiesLoading ||
		usersLoading ||
		lessonsLoading;

	function onChangeTwo(date, dateString) {
		setDate(dateString);
	}

	const handleComm = (option) => {
		console.log(option);
		if (option === "other") {
			setSpecify(true);
		}
		else {
			setSpecify(false);
		}
	}

	useEffect(() => {
		setInteraction(props.interaction);
		console.log(props.interaction)
		if (userArray) {
			var tempArray = [];
			userArray.map((user) => {
				var commObject = {
					name: user.firstname + " " + user.surname,
					id: user.id,
				}

				tempArray.push(commObject);
			});
			tempArray.push({ name: "Other", id: "other" });
			setCommArray([...tempArray]);
		}
	}, [props.interaction, userArray]);

	const handleFileUpload = (e) => {
		console.log(e.target.id);
		const fileObject = {
			"fileID": e.target.id,
			"file": e.target.files[0]
		}
		if (!filesList.includes(fileObject)) {
			var index = filesList.findIndex(x => x.fileID === fileObject.fileID);
			console.log(index);
			if (index !== -1) {
				filesList.splice(index, 1);
				setFilesList(filesList => [...filesList, fileObject]);
			} else {
				setFilesList(filesList => [...filesList, fileObject]);
			}
		}
	}

	const addFile = (fileObject) => {
		console.log(fileObject.folderID);

		uploadBytes(storageRef(storage, "talmidsdb/Interactions/" + fileObject.folderID + "/" + fileObject.fileID),
			fileObject.file).then((item) => {
				getDownloadURL(item.ref)
					.then((url) => {
						var docName = item.ref.name;
						var obj = {};
						obj[docName] = url;
						update(ref(db, `talmidsdb/interactions/${interaction?.interactionID || interaction?.id}/media/`), obj)
					});
			});
	}

	const functionWithPromise = object => { //a function that returns a promise
		addFile(object);
	}

	const anAsyncFunction = async item => {
		return functionWithPromise(item)
	}
	const addImageArray = async (list) => {
		return await Promise.all(list.map(item => anAsyncFunction(item)))
	}

	const handleEdit = (values) => {
		if (!canUpdateInteraction) {
			message.error("You do not have permission to update interactions.");
			return;
		}

		setShowLoading(true);
		var objectID = interaction?.interactionID || interaction?.id;
		var timeStamp = moment().format("YYYY-MM-DDTH:mm:ss");
		setFolderID(objectID);
		var interactionObject = {
			"interactionType": values.interactionType ? values.interactionType : "",
			"countMales": values.countMales ? values.countMales : "",
			"countFemales": values.countFemales ? values.countFemales : "",
			"countChildrenYouth": values.countChildrenYouth ? values.countChildrenYouth : "",
			"notes": values.notes ? values.notes : "",
			"commitments": values.commitments ? values.commitments : "",
			"countDisability": values.countDisability ? values.countDisability : "",
			"countElderly": values.countElderly ? values.countElderly : "",
			"dateTime": values.dateTime ? values.dateTime.format("YYYY-MM-DDTh:mm") : "",
			"lessonId": values.lessonId ? values.lessonId : "",
			"communityID": values.communityID ? values.communityID : "",
			"organisationID": values.organisationID ? values.organisationID : "",
			"userID": values.worker ? values.worker : "",
			"id": objectID,
			"timeStamp": timeStamp,
			"communicatedWithId": (values.communicatedWithId ? values.communicatedWithId : ""),
		}
		if (values.communicatedName !== "" || values.communicatedName !== undefined) {
			interactionObject.communicatedWithOther = values.communicatedName ? values.communicatedName : "";
		}

		const output = FireFetch.UpdateInDB("interactions", objectID, interactionObject);
		output.then((result) => {
			if (result === "success") {
				FireFetch.addLog("Interactions", objectID, "Edit");
				message.success("Interaction edited successfully");
				props.modal(false);
				setSpecify(false);
				setShowLoading(false);
			} else {
				message.error("Unable to edit interaction and error occurred :: " + result);
				setShowLoading(false);
				setSpecify(false);

			}
		}).catch((error) => {
			message.error("Unable to edit interaction and error occurred :: " + error);
			setShowLoading(false);
			setSpecify(false);
		});


		if (filesList.length > 0) {
			filesList.map((file) => {
				file.folderID = objectID;
			});
			addImageArray(filesList)
				.then((r) => {

				}).catch((err) => {
					message.error("Unable to add interaction and error occurred :: " + err);
					setShowLoading(false);
					setSpecify(false);
				})
		}
	}

	if (isLookupLoading) {
		return <Skeleton active paragraph={{ rows: 10 }} />;
	}

	return (
		<>
			<Form layout={"vertical"}
				onFinish={handleEdit}
				initialValues={{
					type: interaction?.interactionType,
					lessonId: interaction?.lessonId,
					organisation: interaction?.organisationID,
					community: interaction?.communityID,
					communicatedWith: interaction?.communicatedWith,
					communicatedName: interaction?.communicatedWith,
					worker: interaction?.userID,
					countMales: interaction?.countMales,
					countFemales: interaction?.countFemales,
					countChildrenYouth: interaction?.countChildrenYouth,
					countDisability: interaction?.countDisability,
					countElderly: interaction?.countElderly,
					dateTime: interaction?.dateTime !== "" ? moment(interaction?.dateTime, "YYYY-MM-DDThh:mm") : null,
					notes: interaction?.notes,
					commitments: interaction?.commitments,
				}}
			>
				<Form.Item label="Interaction Type"
					name="interactionType"
					rules={[{ message: 'Choose interaction type!' }]}>
					<Select placeholder="Select Interaction Type"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}>
						{[{ label: "Whatsapp Or Text" }, { label: "Taught lesson" },
						{ label: "Visit Or Meeting" }, { label: "Phone Call" }].map((item, index) => (
							<Select.Option value={item.label}>{item.label}</Select.Option>
						))}

					</Select>
				</Form.Item>
				<Form.Item label="Lesson"
					name="lesson">
					<Select placeholder="Select Lesson"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}>
						{lessonArray.map((item, index) => (
							<Select.Option key={index} value={item.ID}>{item.lesson}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Organization"
					name="organisationID"
					rules={[{ message: 'Choose Organization!' }]}>
					<Select placeholder="Select organisation"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}>
						{organizationArray.map((item, index) => (
							<Select.Option key={index} value={item.orgID}>{item.name}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Community"
					name="communityID"
					rules={[{ message: 'Choose Community!' }]}>
					<Select placeholder="Select community"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}>
						{communityArray.map((item, index) => (
							<Select.Option key={index} value={item.communityID}>{item.name}</Select.Option>
						))}

					</Select>
				</Form.Item>
				<Form.Item label="Communicated With"
					name="communicatedWithId">
					<Select placeholder="Select who the interaction was with"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions} onChange={handleComm}>
						{commArray.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
						))}

					</Select>
				</Form.Item>
				<Form.Item label="Communicated With Other"
					name="communicatedWithOther">
					<Input placeholder="Enter the fullName of communicated with other" id="" />
				</Form.Item>
				<Form.Item label="Worker"
					name="worker"
					rules={[{ message: 'Choose Worker!' }]}>
					<Select placeholder="Select worker"
						showSearch
						optionFilterProp="children"
						filterOption={filterSelectOption}
						filterSort={sortSelectOptions}>
						{userArray.map((item, index) => (
							<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item label="Males" name="countMales">
					<Input placeholder="male count" type="number" id="countMales" />
				</Form.Item>
				<Form.Item label="Females" name="countFemales">
					<Input placeholder="female count" type="number" id="countFemales" />
				</Form.Item>
				<Form.Item label="Youths" name="countChildrenYouth">
					<Input placeholder="youth child" type="number" id="countChildrenYouth" />
				</Form.Item>
				<Form.Item label="Number of disabled that attended"
					name={"countDisability"}>
					<Input placeholder="number of disabled" type="number" id="countDisability" />
				</Form.Item>
				<Form.Item label="Number of elderly that attended"
					name={"countElderly"}>
					<Input placeholder="number of elderly" type="number" id="countElderly" />
				</Form.Item>
				<Form.Item
					label="Date of Interaction"
					name="dateTime"
				>
					<DatePicker
						placeholder="select ending date"
						picker={"date"}
						showTime={{ format: 'HH:mm' }}
						//defaultValue={moment('1990-01-01', 'YYYY-MM-DD')}
						className="w-100"
						onChange={onChangeTwo} />

				</Form.Item>
				<Form.Item label="Notes" name="notes">
					<TextArea placeholder="notes" id="notes" />
				</Form.Item>
				<Form.Item label="Commitments" name="commitments">
					<TextArea placeholder="commitments" id="commitments" />
				</Form.Item>
				<Form.Item label="Upload Photo of Participants">
					<Input type="file"
						style={{ width: "100%" }}
						accept="image/*"
						onChange={handleFileUpload}
						placeholder="first image" id="photoParticipants" />
					<Text size={300} className=" w-50">{interaction?.media?.photoParticipants ?
						interaction?.media?.photoParticipants.substring(0, 70) + '...' : "no saved file"}</Text>
				</Form.Item>
				<Form.Item label="Upload Photo of Attendance List">
					<Input type="file"
						style={{ width: "100%" }}
						accept="image/*"
						onChange={handleFileUpload}
						placeholder="second image" id="photoAttendance" />
					<Text size={300} className=" w-50">
						{interaction?.media?.photoAttendance ?
							interaction?.media?.photoAttendance.substring(0, 70) + '...' : "no saved file"}
					</Text>
				</Form.Item>
				<Form.Item label="Upload Photo Document">
					<Input type="file"
						style={{ width: "100%" }}
						accept="image/*"
						onChange={handleFileUpload}
						placeholder="third image" id="photoDocument" />
					<Text size={300} className=" w-50">
						{interaction?.media?.photoDocument ?
							interaction?.media?.photoDocument.substring(0, 70) + '...' : "no saved file"}
					</Text>
				</Form.Item>


				<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canUpdateInteraction}>
					Edit
				</Button>
			</Form>
		</>
	)
}

export default EditInteraction;
